import { GatewayChannelWithChargePointInfoModel } from '@delmonicos/shared-sdk/libs/cpms/src/apps/charge-point-operators-gateway/src/charge-points/models/outputs/gateway-channel-with-charge-point-info.model';
import { IdentifiedColumnDef } from '@tanstack/react-table';

import { ChannelListNetworkCell } from './channel-list-network.cell';
import { ChannelListNetworkHeader } from './channel-list-network.header';

export const ChannelListNetworkColumn: IdentifiedColumnDef<
  GatewayChannelWithChargePointInfoModel,
  GatewayChannelWithChargePointInfoModel['network']
> = {
  enableSorting: false,
  header: ChannelListNetworkHeader,
  cell: ChannelListNetworkCell,
};
